import script from "./TodoDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TodoDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./TodoDetailModal.vue?vue&type=style&index=0&id=10d7760b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10d7760b"]])

export default __exports__